import { render, staticRenderFns } from "./GuidelinesDetailManage.vue?vue&type=template&id=70825d37&scoped=true"
import script from "./GuidelinesDetailManage.vue?vue&type=script&lang=js"
export * from "./GuidelinesDetailManage.vue?vue&type=script&lang=js"
import style0 from "./GuidelinesDetailManage.vue?vue&type=style&index=0&id=70825d37&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70825d37",
  null
  
)

export default component.exports